module.exports = __webpack_public_path__ + "static/media/24.6ba3696b.jpg";